// extracted by mini-css-extract-plugin
module.exports = {"root":"IconCalendarViewWeek_root__FvDk1"};